import script from "./PublicationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationItem.vue?vue&type=script&setup=true&lang=js"

import "./PublicationItem.vue?vue&type=style&index=0&id=91f0358c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91f0358c"]])

export default __exports__